/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch} from 'react-redux'
import {LocationModel, LocationTableModelInitValues} from '../models/LocationModel'
import {remove} from '../redux/LocationAction'
import {toast} from 'react-toastify'

interface Props {
  show: boolean
  handleClose: () => void
  location: LocationModel
}

export const LocationDelete: FC<Props> = ({show, handleClose, location}) => {
  const dispatch: any = useDispatch()
  const [loading, setLoading] = useState(false)
  const deleteLocation = () => {
    setLoading(true)
    dispatch(remove(location?._id, LocationTableModelInitValues))
      .then((response: any) => {
        toast.success(response)
        setLoading(false)
        handleClose()
      })
      .catch((error: any) => {
        toast.error(error)
        setLoading(false)
      })
  }

  return (
    <Modal
      id='kt_modal_delete_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-500px h-auto'
      show={show}
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h2>Delete Product </h2>
        </div>

        <div className='modal-body flex-row-fluid py-lg-10 px-lg-10'>
          <p className='d-flex align-items-center fs-5 fw-bold'>
            Are you sure you want to delete this location ({location?.name})?
          </p>
          <div className='d-flex flex-stack mt-5'>
            <button
              type='button'
              className='btn btn-lg btn-light-primary float-left'
              onClick={() => {
                handleClose()
              }}
            >
              Cancel
            </button>
            <button
              title='Delete'
              type='submit'
              className='btn btn-lg btn-primary float-left'
              onClick={() => {
                deleteLocation()
              }}
              disabled={loading}
            >
              <span className='indicator-label'>{loading ? 'Deleting...' : 'Delete'}</span>
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
